import { useCallback, useEffect, useRef, useState } from "react";
import { scrollToTop, sendGtag, useWindowSize } from "../../utils";
import style from "./Footer.module.scss";
import cx from "classnames";
import {
  FacebookMessengerShareButton,
  FacebookShareButton,
  OKShareButton,
  TwitterShareButton,
  VKShareButton,
} from "react-share";

const ToTop = () => {
  const onClick = useCallback(() => {
    scrollToTop();
  }, []);
  return (
    <button onClick={onClick} className={style["to-top"]}>
      <img src="/images/toTop.svg" alt="share" />
    </button>
  );
};

function useOuterClick(callback: React.MouseEventHandler<HTMLElement>) {
  const callbackRef = useRef<React.MouseEventHandler<HTMLElement>>(); // initialize mutable ref, which stores callback
  const innerRef = useRef<HTMLElement>(); // returned to client, who marks "border" element

  // update cb on each render, so second useEffect has access to current value
  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
    function handleClick(e: any) {
      if (
        innerRef.current &&
        callbackRef.current &&
        !innerRef.current.contains(e.target)
      )
        callbackRef.current(e);
    }
  }, []); // no dependencies -> stable click listener

  return innerRef; // convenience for client (doesn't need to init ref himself)
}

export const Footer = () => {
  const { width } = useWindowSize();
  return (
    <footer className={style.footer}>
      {width && width > 950 ? (
        <div className={`${style.footer__wrapper} wrapper`}>
          <ShareButton />
          <Partners />
          <ToTop />
        </div>
      ) : (
        <div className={`${style["wrapper-mobile"]}`}>
          <div className={`${style.footer__wrapper} wrapper`}>
            <ShareButton />
            <ToTop />
          </div>
          <Partners />
        </div>
      )}
    </footer>
  );
};

const ShareButton = () => {
  const [folded, setFolded] = useState(true);
  const timeoutRef = useRef<NodeJS.Timeout>();
  const ref = useOuterClick(() => {
    setFolded(true);
  });
  const onClick = useCallback(() => {
    setFolded((prev) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (prev) {
        timeoutRef.current = setTimeout(() => {
          setFolded(true);
        }, 10000);
      }
      return !prev;
    });
  }, []);
  return (
    <>
      <SharePopUp folded={folded} />

      <button
        //@ts-ignore
        ref={ref}
        onMouseEnter={onClick}
        onClick={onClick}
        className={style.share}
      >
        <img src="/images/share.svg" alt="share" />
      </button>
    </>
  );
};

const sendGtagWrapper = (
  e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
) => {
  //@ts-ignore
  const category = e.target.dataset.category;
  //@ts-ignore
  const action = e.target.dataset.action;
  //@ts-ignore
  const label = e.target.dataset.label;
  sendGtag(category, action, label);
};

const Partners = () => {
  return (
    <div className={style["partners-container"]}>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://хайгир.рф/?utm_source=motor&utm_medium=cpc&utm_campaign=hg"
        data-category="external"
        data-action="click"
        data-label="logo_HG"
        onClickCapture={sendGtagWrapper}
      >
        <img
          className={style["hi-gear"]}
          src="/images/logos/Hi-Gear.svg"
          alt=""
        />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://smt-2.ru/?utm_source=motor&utm_medium=cpc&utm_campaign=smt2"
        data-category="external"
        data-action="click"
        data-label="logo_SMT"
        onClick={sendGtagWrapper}
      >
        <img className={style.smt} src="/images/logos/SMT.svg" alt="" />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.aga-products.ru/?utm_source=motor&utm_medium=cpc&utm_campaign=aga"
        data-category="external"
        data-action="click"
        data-label="logo_AGA"
        onClick={sendGtagWrapper}
      >
        <img className={style.aga} src="/images/logos/AGA.svg" alt="" />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://doctorwax.ru/?utm_source=motor&utm_medium=cpc&utm_campaign=dw"
        data-category="external"
        data-action="click"
        data-label="logo_DW"
        onClick={sendGtagWrapper}
      >
        <img
          className={style["doctor-wax"]}
          src="/images/logos/DoctorWax.svg"
          alt=""
        />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://done-deal.ru/?utm_source=motor&utm_medium=cpc&utm_campaign=dd"
        data-category="external"
        data-action="click"
        data-label="logo_DD"
        onClick={sendGtagWrapper}
      >
        <img
          className={style["done-deal"]}
          src="/images/logos/DoneDeal.svg"
          alt=""
        />
      </a>
    </div>
  );
};

const SharePopUp = ({ folded }: { folded: boolean }) => {
  return (
    <div
      className={cx(style.sharePopup, {
        [style.sharePopupFolded]: folded,
      })}
    >
      <ShareIconFB />
      <ShareIconVK />
      <ShareIconOK />
      <ShareIconTW />
    </div>
  );
};

const quote =
  "Как защитить любимую машину от дождей, холодов, русской зимы, не всегда хороших дорог? Можно ли надолго сохранить ее красоту и здоровье без помощи автосервисов, самостоятельно? Ответ: да. Нужно лишь создать вашему авто иммунитет. Но для этого необходимо знать, какими средствами автохимии и автокосметики пользоваться. Мы собрали самую подробную информацию по уходу за автомобилем – для тех, кто полагается только на себя и испытывает удовольствие, помогая ему выглядеть и ездить на все 100. Подарите вашей машине настоящий иммунитет!";
const title = "Стойкий иммунитет вашей машины";

const ShareIconFB = () => {
  const [hover, setHover] = useState(false);
  return (
    <FacebookShareButton
      url={"https://azbuka-avtohimii.motor.ru"}
      quote={quote}
      title={title}
    >
      <svg
        width="72"
        height="74"
        viewBox="0 0 72 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <path
          d="M71.4997 37.0498C71.4997 56.7611 55.6034 72.7359 35.9998 72.7359C16.3963 72.7359 0.5 56.7611 0.5 37.0498C0.5 17.3385 16.3963 1.36377 35.9998 1.36377C55.6034 1.36377 71.4997 17.3385 71.4997 37.0498Z"
          fill={hover ? "#D12630" : "white"}
          stroke="#D12630"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M37.6214 31.5976V28.4841C37.6214 27.1349 37.9328 26.4084 40.1122 26.4084H42.8106V21.2192H38.6593C33.4701 21.2192 31.3944 24.6441 31.3944 28.4841V31.5976H27.2431V36.7867H31.3944V52.3542H37.6214V36.7867H42.1879L42.8106 31.5976H37.6214Z"
          fill={!hover ? "#D12630" : "white"}
        />
      </svg>
    </FacebookShareButton>
  );
};
const ShareIconVK = () => {
  const [hover, setHover] = useState(false);
  return (
    <VKShareButton
      url={"https://azbuka-avtohimii.motor.ru"}
      image={process.env.PUBLIC_URL + "/share.png"}
      title={title}
    >
      <svg
        width="72"
        height="73"
        viewBox="0 0 72 73"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <path
          d="M71.4997 36.4287C71.4997 56.14 55.6034 72.1148 35.9998 72.1148C16.3963 72.1148 0.5 56.14 0.5 36.4287C0.5 16.7174 16.3963 0.742676 35.9998 0.742676C55.6034 0.742676 71.4997 16.7174 71.4997 36.4287Z"
          fill={hover ? "#D12630" : "white"}
          stroke="#D12630"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.5432 47.7063H35.7917C35.7917 47.7063 36.4663 47.5932 36.8035 47.2537C37.1408 46.9143 37.1408 46.2354 37.1408 46.2354C37.1408 46.2354 37.1408 43.2937 38.4899 42.8412C39.839 42.3886 41.6378 45.7829 43.4366 47.0274C44.7857 48.0457 45.9099 47.8194 45.9099 47.8194L50.8566 47.7063C50.8566 47.7063 53.4423 47.5931 52.2057 45.4434C52.0933 45.3303 51.5311 43.9726 48.4957 41.144C45.3478 38.2023 45.7975 38.7681 49.5075 33.6767C51.756 30.6218 52.6554 28.8115 52.4305 27.9064C52.2057 27.1144 50.5193 27.3407 50.5193 27.3407H44.8981C44.8981 27.3407 44.4484 27.3407 44.2235 27.4539C43.8863 27.6801 43.7738 28.0196 43.7738 28.0196C43.7738 28.0196 42.8744 30.3955 41.7502 32.4321C39.2769 36.6183 38.265 36.8446 37.9278 36.6183C37.0284 36.0526 37.2532 34.1292 37.2532 32.8847C37.2532 28.8115 37.9278 27.1144 36.0165 26.6618C35.4544 26.5487 35.0047 26.4355 33.4308 26.4355C31.4072 26.4355 29.7208 26.4356 28.8214 26.8881C28.1468 27.2276 27.6972 27.9064 28.0344 27.9064C28.3717 27.9064 29.2711 28.1327 29.7208 28.6984C30.2829 29.4904 30.2829 31.1875 30.2829 31.1875C30.2829 31.1875 30.6202 36.0526 29.4959 36.6183C28.709 37.0709 27.6972 36.1658 25.4487 32.319C24.3244 30.3955 23.425 28.1327 23.425 28.1327C23.425 28.1327 23.3126 27.6801 22.9753 27.4539C22.6381 27.2276 22.0759 27.1144 22.0759 27.1144H16.792C16.792 27.1144 16.005 27.1144 15.6677 27.4539C15.4429 27.7933 15.6677 28.359 15.6677 28.359C15.6677 28.359 19.8274 38.0892 24.5493 43.0675C28.5965 48.0457 33.5432 47.7063 33.5432 47.7063Z"
          fill={!hover ? "#D12630" : "white"}
        />
      </svg>
    </VKShareButton>
  );
};
const ShareIconOK = () => {
  const [hover, setHover] = useState(false);
  return (
    <OKShareButton
      url={"https://azbuka-avtohimii.motor.ru"}
      image={process.env.PUBLIC_URL + "/share.png"}
      description={quote}
      title={title}
    >
      <svg
        width="72"
        height="73"
        viewBox="0 0 72 73"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <path
          d="M71.4997 36.8071C71.4997 56.5184 55.6034 72.4932 35.9998 72.4932C16.3963 72.4932 0.5 56.5184 0.5 36.8071C0.5 17.0958 16.3963 1.12109 35.9998 1.12109C55.6034 1.12109 71.4997 17.0958 71.4997 36.8071Z"
          fill={hover ? "#D12630" : "white"}
          stroke="#D12630"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.9998 35.6482C31.1836 35.6482 27.2431 31.7077 27.2431 26.8915C27.2431 22.0753 31.1836 18.1348 35.9998 18.1348C40.816 18.1348 44.7565 22.0753 44.7565 26.8915C44.7565 31.7077 40.816 35.6482 35.9998 35.6482ZM35.9998 22.2942C33.4823 22.2942 31.4025 24.3739 31.4025 26.8915C31.4025 29.409 33.4823 31.4888 35.9998 31.4888C38.5174 31.4888 40.5971 29.409 40.5971 26.8915C40.5971 24.3739 38.5174 22.2942 35.9998 22.2942Z"
          fill={!hover ? "#D12630" : "white"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M46.253 36.522C45.4205 35.5637 43.9934 35.4573 42.9231 36.0961C42.9231 36.0961 40.3068 37.7997 36.0255 37.7997C31.7442 37.7997 29.1279 36.0961 29.1279 36.0961C28.0576 35.3508 26.6305 35.5637 25.798 36.522C24.9655 37.4803 25.2034 38.758 26.2737 39.5033C26.3926 39.6097 28.8901 41.3134 33.0524 41.8457L26.7494 47.5954C25.798 48.4472 25.798 49.8313 26.7494 50.5766C27.2251 51.0025 27.8197 51.2155 28.4143 51.2155C29.009 51.2155 29.6036 51.0025 30.0793 50.5766L36.0255 45.1465L41.9717 50.5766C42.4474 51.0025 43.042 51.2155 43.6367 51.2155C44.2313 51.2155 44.8259 51.0025 45.3016 50.5766C46.253 49.7248 46.253 48.4472 45.3016 47.5954L38.9986 41.8457C43.161 41.2069 45.6584 39.5033 45.7773 39.5033C46.8476 38.758 46.9665 37.3738 46.253 36.522Z"
          fill={!hover ? "#D12630" : "white"}
        />
      </svg>
    </OKShareButton>
  );
};
const ShareIconTW = () => {
  const [hover, setHover] = useState(false);
  return (
    <TwitterShareButton
      url={"https://azbuka-avtohimii.motor.ru"}
      via={quote}
      title={title}
    >
      <svg
        width="72"
        height="73"
        viewBox="0 0 72 73"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <path
          d="M71.4997 36.1861C71.4997 55.8974 55.6034 71.8721 35.9998 71.8721C16.3963 71.8721 0.5 55.8974 0.5 36.1861C0.5 16.4748 16.3963 0.5 35.9998 0.5C55.6034 0.5 71.4997 16.4748 71.4997 36.1861Z"
          fill={hover ? "#D12630" : "white"}
          stroke="#D12630"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M52.5399 27.1049C51.371 27.6341 50.2021 27.9516 48.8207 28.1633C50.0959 27.3166 51.1585 26.1523 51.6898 24.6704C50.4147 25.4113 49.0332 25.9406 47.6518 26.2581C46.4829 24.988 44.7827 24.2471 42.9763 24.2471C39.4696 24.2471 36.4942 27.1049 36.4942 30.7037C36.4942 31.2329 36.6005 31.6563 36.7068 32.1855C31.3936 31.9738 26.6118 29.3276 23.4239 25.5172C22.8926 26.4698 22.5738 27.5282 22.5738 28.6926C22.5738 30.9153 23.7427 32.9264 25.4429 33.9849C24.3803 33.9849 23.4239 33.6673 22.4675 33.1381V33.244C22.4675 36.3135 24.6991 38.9596 27.6744 39.4889C27.1431 39.5947 26.6118 39.7006 25.9742 39.7006C25.5492 39.7006 25.1241 39.7006 24.8053 39.5948C25.6554 42.1351 27.9932 44.0402 30.8623 44.0402C28.6308 45.7338 25.8679 46.7923 22.8926 46.7923C22.3613 46.7923 21.83 46.7922 21.4049 46.6864C24.274 48.4858 27.5682 49.5443 31.2874 49.5443C43.0825 49.5443 49.5646 39.8064 49.5646 31.3387C49.5646 31.0212 49.5646 30.8095 49.5646 30.492C50.5209 29.5393 51.5835 28.4809 52.5399 27.1049Z"
          fill={!hover ? "#D12630" : "white"}
        />
      </svg>
    </TwitterShareButton>
  );
};
